import { computed, ref } from '@vue/composition-api';
import { defineStore } from 'pinia';

export const useSessionStore = defineStore('session', () => {
  const token = ref({ jwt: '', exp: 0 });
  const documentId = ref('');
  const recipientId = ref('');
  const authId = ref('');

  const setToken = (newToken: { jwt: string; exp: number }) => (token.value = newToken);
  const setAuthId = (newAuth: string) => (authId.value = newAuth);
  const setDocumentId = (newDocumentId: string) => (documentId.value = newDocumentId);
  const setRecipientId = (newRecipientId: string) => (recipientId.value = newRecipientId);

  const tokenLoaded = computed(() => !!token.value.jwt && !!token.value.exp);

  const reset = () => {
    token.value = { jwt: '', exp: 0 };
    documentId.value = '';
    recipientId.value = '';
    authId.value = '';
  };

  return {
    token,
    documentId,
    recipientId,
    authId,
    tokenLoaded,
    setToken,
    setAuthId,
    setDocumentId,
    setRecipientId,
    reset,
  };
});
